import { render, staticRenderFns } from "./VPuzzle.vue?vue&type=template&id=cb252fc2&"
import script from "./VPuzzle.vue?vue&type=script&lang=ts&"
export * from "./VPuzzle.vue?vue&type=script&lang=ts&"
import style0 from "./VPuzzle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports